import { useFormContext } from 'react-hook-form';
import { FILTER_SECTIONS, Filter } from '@anytag/shared-molecules';
import {
  AgeField,
  FollowerField,
  VideoPostPriceField,
  ImagePostPriceField,
  AudienceDemographics,
  InfluencerStatusField,
  RegionAndProvinceField,
  InfluencerCategoryField,
  TalentAgencyPartnerField,
  EngagementFollowersAndViewsRateField
} from '../../shared';
import { AdvancedFilterDefaultProps } from '../../schemaTypes';
import { defaultXhsInfluencersFormValues, XhsInfluencersFilterFormValues } from '../schemaTypes';

export const AdvancedFilter = ({ count, onSubmit }: AdvancedFilterDefaultProps) => {
  const { reset, getValues } = useFormContext<XhsInfluencersFilterFormValues>();

  const values = getValues();

  const handleClear = () => {
    reset({
      ...defaultXhsInfluencersFormValues,
      // Basic filter
      keyword: values.keyword,
      genders: values.genders,
      countryIds: values.countryIds
    });
  };

  return (
    <Filter.MoreFilterPopover
      count={count}
      onClear={handleClear}
      onSubmit={onSubmit}
      items={[
        {
          value: FILTER_SECTIONS.InfluencerAttributes,
          title: FILTER_SECTIONS.InfluencerAttributes,
          node: (
            <>
              <AgeField />
              <InfluencerStatusField />
              <TalentAgencyPartnerField />
              <InfluencerCategoryField />
              <RegionAndProvinceField />
            </>
          )
        },
        {
          value: FILTER_SECTIONS.PerformanceFilter,
          title: FILTER_SECTIONS.PerformanceFilter,
          node: (
            <>
              <FollowerField />
              <EngagementFollowersAndViewsRateField />
              <ImagePostPriceField />
              <VideoPostPriceField />
            </>
          )
        },
        {
          value: FILTER_SECTIONS.Audiences,
          title: 'Audience Demographics',
          node: <AudienceDemographics />
        }
      ]}
    />
  );
};
